<template>
  <div class="widget-wrapper">
  <StackedChart :data="data"/>
  </div>
</template>

<script>
import _ from 'lodash'
import StackedChart from '@/components/widgets/StackedChart'

export default {
  components: {
    StackedChart,
  },
  props: {
    items: Array,
    unfiltered: Array,
    emitSelection: Function,
    handleSort: Function,
    updatePagination: Function,
    selection: Array,
    pagination: Object,
    headers: Array,
    actions: Array,
    hasActions: Boolean,
    totalCount: Number,
  },
  computed: {
    data () {
      return _(this.unfiltered)
        .groupBy('name')
        .map((value, key) => ({
          name: key,
          data: _.reduce(value, (result, item) => {
            result[item.period] = item.value
            return result
          }, {}),
        }))
        .value()
    },
  },
}
</script>
<style>
.widget-wrapper {
  padding: 10px 10px;
}
</style>
